import { Box, Grid, Typography, useMediaQuery } from "@mui/material"
import offeringBanner from '../../assets/image/landing/products.png';


const LandingProductsComponent = () => {

    const isSmallScreen = useMediaQuery('(max-width:600px)'); 


    return (
        <Box>

            <Grid container sx={{ textAlign: 'center', position: 'relative' }}>
                <Grid item xs={12} sm={12}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 60, textAlign: 'center', color: '#08244d', mt: 2, mb: 2 }}>
                        Products
                    </Typography >
                </Grid>
            </Grid>
            <br />
            <Box
                style={{
                    backgroundImage: `url(${offeringBanner})`,
                    backgroundSize: 'cover',
                    backgroundPosition:  isSmallScreen ? 'center' : 'bottom',
                    height: isSmallScreen ? '20vh' : '80vh', 
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'flex-start', 
                    padding: '20px',
                }}
            ></Box>
        </Box>
    )
}

export default LandingProductsComponent